// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading__2rvbH","spinning":"style_spinning__3-LBy"};